import { inject } from '@angular/core';
import { RedirectCommand, ResolveFn, Router } from '@angular/router';
import { ToastService, ToastType } from '@app/components/toast';
import {
  Challenge,
  ChallengeService,
} from '@app/services/challenge/challenge.service';
import { TranslatorService } from '@app/services/translator/translator.service';
import { catchError, map, of } from 'rxjs';

export const stepChallengeResolver: ResolveFn<Challenge | RedirectCommand> = (
  route
) => {
  const challengeService = inject(ChallengeService);
  const router = inject(Router);
  const toastService = inject(ToastService);
  const translatorService = inject(TranslatorService);
  const id = route.paramMap.get('id') ?? '';

  return challengeService.getStepChallenge(id).pipe(
    map((challenge) => {
      if (!challenge) {
        throw new Error('Challenge not found');
      }
      return challenge;
    }),
    catchError(() => {
      toastService.add(
        translatorService.translate('challenges.challengeCouldNotBeLoaded'),
        ToastType.ERROR
      );
      return of(new RedirectCommand(router.parseUrl('/challenges')));
    })
  );
};
